import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import LinkType from "%/dynamic-component-editor/options/link-type";
import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";

import { titleToKebabCase } from "@bloglovin/vue-framework";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useConfigurationPanelStore = (...args) => require("%/dynamic-component-editor/stores/configuration-panel-store").useConfigurationPanelStore(...args);
// eslint-disable-next-line global-require
const useGeneralStore = (...args) => require("%/dynamic-component-editor/stores/general-store").useGeneralStore(...args);
// eslint-disable-next-line global-require
const useFanPublicationStore = (...args) => require("%/dynamic-component-editor/stores/fan-publication-store").default(...args);


export default class HrefOption extends BaseOption {
  static userInterfaceComponent = (optionsValues = {}) => {
    const linkType = new LinkType().getValueFromConfiguration(optionsValues);
    switch (linkType) {
      case LinkType.LINK_TYPE_PAGE:
        return {
          label: "Link",
          component: inspectorTools.AUTOCOMPLETE,
          props: {
            isAsync: true,
            showAllResultsOnClick: true,
            sourceUrl: () => {
              return useGeneralStore().apiV1 + `/publication/${useFanPublicationStore().publicationId}/pages/autocomplete`;
            },
            itemValueKey: "value",
            itemLabelKey: "label",
            canCreateNewItem: true,
            customItemLabel: "Create new page",
            placeholder: "Search pages...",
            runInitialSearch: true,
            includeValueType: "string",
            onCreateItem: (data, context) => {
              const pageName = data.query;
              const pageSlug = titleToKebabCase(pageName);

              useConfigurationPanelStore().createDynamicPage({
                name: pageName,
                slug: pageSlug,
                template: 0,
              }, () => {
                context.setValue({
                  value: pageSlug,
                  label: pageName,
                });
              });
            },
          },
        };
      case LinkType.LINK_TYPE_STORY:
        return {
          label: "Link",
          component: inspectorTools.AUTOCOMPLETE,
          props: {
            isAsync: true,
            sourceUrl: () => {
              return useGeneralStore().apiV1 + `/publication/${useFanPublicationStore().publicationId}/stories/autocomplete`;
            },
            itemValueKey: "value",
            itemLabelKey: "label",
            placeholder: "Search stories...",
            runInitialSearch: true,
          },
        };
      case LinkType.LINK_TYPE_HASHTAG:
        return {
          label: "Link",
          component: inspectorTools.SIMPLE_INPUT,
        };
      case LinkType.LINK_TYPE_HYPERLINK:
        return {
          label: "Link",
          component: inspectorTools.SIMPLE_INPUT,
          props: {
            placeholder: "https://",
          },
        };
      default:
        throw new DynamicComponentError("Invalid link type", {
          "link_type": linkType,
        });
    }
  };

  static validations = [
    (value, optionsValues = {}) => {
      const linkType = new LinkType().getValueFromConfiguration(optionsValues);
      switch (linkType) {
        case LinkType.LINK_TYPE_STORY:
        case LinkType.LINK_TYPE_PAGE:
          break;
        default:
          if (value.includes("\\") || value.includes("/")) {
            if (value.trim() && !/^https:\/\/.*/.test(value)) {
              return "Please enter a valid https url";
            }
          }
      }
    },
  ];

  static defaultValue = "";
}
